const LEGACY_PATH_MAPPINGS: ReadonlyArray<[fromPrefix: string, toPrefix: string]> = [
  ['/coach/players', '/coach/athletes'],
  ['/athlete/coaches', '/player/coaches'],
  ['/athlete', '/player'],
  ['/players', '/player'],
];

const LEGACY_EXACT_MAPPINGS: Readonly<Record<string, string>> = {
  '/athlete': '/player/coaches',
  '/players': '/player/coaches',
};

const ASSIGNMENT_NOTIFICATION_TYPES = new Set([
  'assignment.created',
  'assignment.ended',
  'assignment.activated',
  'assignment.reactivated',
  'assignment.suspended',
]);

export function normalizeAppRoute(rawRoute: string): string {
  const trimmedRoute = rawRoute.trim();
  if (!trimmedRoute) {
    return '';
  }

  const routeWithLeadingSlash = trimmedRoute.startsWith('/') ? trimmedRoute : `/${trimmedRoute}`;
  const [pathPart, suffix = ''] = splitPathAndSuffix(routeWithLeadingSlash);

  const exactMatch = LEGACY_EXACT_MAPPINGS[pathPart];
  if (exactMatch) {
    return `${exactMatch}${suffix}`;
  }

  for (const [fromPrefix, toPrefix] of LEGACY_PATH_MAPPINGS) {
    if (pathPart === fromPrefix || pathPart.startsWith(`${fromPrefix}/`)) {
      const nextPath = `${toPrefix}${pathPart.slice(fromPrefix.length)}`;
      return `${nextPath}${suffix}`;
    }
  }

  return `${pathPart}${suffix}`;
}

export function resolveNotificationRoute(data: Record<string, unknown> | undefined): string {
  const deepLink = readString(data, 'deep_link').trim();
  if (deepLink) {
    return normalizeAppRoute(deepLink);
  }

  const typeCode = readString(data, 'type_code').toLowerCase();
  if (ASSIGNMENT_NOTIFICATION_TYPES.has(typeCode)) {
    return '/admin/assignments';
  }

  return '';
}

function splitPathAndSuffix(route: string): [path: string, suffix: string] {
  const queryOrHashIndex = route.search(/[?#]/);
  if (queryOrHashIndex === -1) {
    return [route, ''];
  }

  return [route.slice(0, queryOrHashIndex), route.slice(queryOrHashIndex)];
}

function readString(data: Record<string, unknown> | undefined, key: string): string {
  if (!data) {
    return '';
  }

  const value = data[key];
  if (typeof value === 'string') {
    return value;
  }
  if (value === null || value === undefined) {
    return '';
  }

  return String(value);
}